import { render, staticRenderFns } from "./AdditionalFindings.vue?vue&type=template&id=2bb1b8f4&scoped=true&"
import script from "./AdditionalFindings.vue?vue&type=script&lang=js&"
export * from "./AdditionalFindings.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalFindings.vue?vue&type=style&index=0&id=2bb1b8f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb1b8f4",
  null
  
)

export default component.exports